import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Home from "./home";
import Profile from "./profile";
import About from './about'
// import Activity from "./activity";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/index"),
    children: [
      {
        path: "/",
        redirect: "/summary"
      },
      ...Home,
      ...Profile,
      ...About,
    ]
  },
  {
    path: "/activity/xfjd/national",
    name: "Activity",
    component: () => import("../views/activity/xfjd/national"),
  },
  {
    path: "/activity/ruqi/ad",
    name: "ruqi_ad",
    component: () => import("../views/activity/ruqi/ad"),
  },
  {
    path: "/activity/ruqi/hz_ad",
    name: "ruqi_hz_ad",
    component: () => import("../views/activity/ruqi/hz_ad"),
  },
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  // },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
